import { User } from 'firebase/auth';
import { atom } from 'recoil';

const auth = atom<User | null>({
  key: 'auth',
  default: null,
  dangerouslyAllowMutability: true,
});

export default auth;
